import type { LngLat } from "@/utils/mapboxStatic/types";

/**
 * ZIP-first geocoding query for the piece's destination, or `null` when the
 * response carries no `destination_zip` (callers then hide every destination
 * element).
 */
export function getDestinationQuery(data: {
  destination_zip: string | null;
}): string | null {
  const zip = data.destination_zip?.trim();
  if (!zip) return null;
  const match = zip.match(/\b(\d{5})(?:-\d{4})?\b/);
  return match ? match[1] : zip;
}

const EARTH_RADIUS_MILES = 3958.8;

/** Great-circle distance between two points, in miles. */
export function haversineMiles(a: LngLat, b: LngLat): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_MILES * Math.asin(Math.min(1, Math.sqrt(h)));
}

/** The two endpoints of the dashed "estimated remaining" segment. */
export function estimatedSegment(
  last: LngLat,
  destination: LngLat,
): [LngLat, LngLat] {
  return [last, destination];
}
